module.exports = __webpack_public_path__ + "static/media/a-year-in-books-2024.a2fa4408.md";